export const vertexShader = `
    varying vec2 vUv;
    varying vec3 vWorldPosition;
    varying vec3 vNormal;

    void main() {
        vUv = uv;
        vec4 worldPos = modelMatrix * vec4(position, 1.0);
        vWorldPosition = worldPos.xyz;
        vNormal = normalize(normalMatrix * normal);
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
`;

export const fragmentShader = `
    uniform sampler2D baseTexture;
    uniform sampler2D compositeTexture1001;
    uniform sampler2D compositeTexture1002;
    uniform sampler2D compositeTexture1003;
    uniform sampler2D compositeTexture1011;
    uniform sampler2D compositeTexture1012;
    uniform sampler2D compositeTexture1013;
    uniform sampler2D decalTexture;
    uniform vec2 decalCenterUV;
    uniform float decalSizeU;
    uniform float decalSizeV;
    uniform float decalOpacity;
    uniform mat3 rotationMatrix;
    uniform bool useComposite;  // Whether to use composite or base texture

    varying vec2 vUv;
    varying vec3 vWorldPosition;
    varying vec3 vNormal;

    // Calculate UDIM tile from UV coordinates
    int calculateUDIMTile(vec2 uv) {
        return int(1001.0 + floor(uv.x) + floor(uv.y) * 10.0);
    }

    // Sample from the appropriate composite texture based on UDIM tile
    vec4 sampleCompositeTexture(vec2 uv) {
        int udimTile = calculateUDIMTile(uv);
        
        // Normalize UV to [0,1] range for the specific tile
        vec2 tileUV = fract(uv);
        
        if (udimTile == 1001) {
            return texture2D(compositeTexture1001, tileUV);
        } else if (udimTile == 1002) {
            return texture2D(compositeTexture1002, tileUV);
        } else if (udimTile == 1003) {
            return texture2D(compositeTexture1003, tileUV);
        } else if (udimTile == 1011) {
            return texture2D(compositeTexture1011, tileUV);
        } else if (udimTile == 1012) {
            return texture2D(compositeTexture1012, tileUV);
        } else if (udimTile == 1013) {
            return texture2D(compositeTexture1013, tileUV);
        } else {
            // Fallback to base texture for unsupported tiles
            return texture2D(baseTexture, tileUV);
        }
    }

    void main() {
        // Use composite texture if available (base + existing decals), otherwise fall back to base
        vec4 baseColor = useComposite ? sampleCompositeTexture(vUv) : texture2D(baseTexture, vUv);
        vec2 uvOffset = vUv - decalCenterUV;

        // Use expanded bounds for rotated decals to prevent clipping
        // Use individual expansion for each axis to allow independent scaling
        float expandedSizeU = decalSizeU * 1.42; // sqrt(2) for diagonal expansion per axis
        float expandedSizeV = decalSizeV * 1.42; // sqrt(2) for diagonal expansion per axis

        float u = uvOffset.x / expandedSizeU + 0.5;
        float v = uvOffset.y / expandedSizeV + 0.5;

        if (u < 0.0 || u > 1.0 || v < 0.0 || v > 1.0) {
            gl_FragColor = baseColor;
            return;
        }

        // Apply rotation
        vec2 centeredUV = vec2(u, v) - 0.5;
        vec3 rotatedUV3 = rotationMatrix * vec3(centeredUV, 0.0);
        vec2 rotatedUV = rotatedUV3.xy + 0.5;

        // Check bounds after rotation
        if (rotatedUV.x < 0.0 || rotatedUV.x > 1.0 || rotatedUV.y < 0.0 || rotatedUV.y > 1.0) {
            gl_FragColor = baseColor;
            return;
        }

        // Scale the rotated UV back to original decal size for sampling
        // Apply independent scaling for U and V axes
        vec2 finalUV;
        finalUV.x = (rotatedUV.x - 0.5) * (expandedSizeU / decalSizeU) + 0.5;
        finalUV.y = (rotatedUV.y - 0.5) * (expandedSizeV / decalSizeV) + 0.5;
        
        // Final bounds check for the scaled UV
        if (finalUV.x < 0.0 || finalUV.x > 1.0 || finalUV.y < 0.0 || finalUV.y > 1.0) {
            gl_FragColor = baseColor;
            return;
        }

        vec4 decalColor = texture2D(decalTexture, finalUV);
        float alpha = decalColor.a * decalOpacity;
        gl_FragColor = mix(baseColor, decalColor, alpha);
    }
`;
